'use strict';

var $ = require('jquery');

/**
 * Extracts product id from quick shop url.
 *
 * @param {jQuery} el - dom element
 * @returns {String} product id
 */
function getPidFromUrl(el) {
    let href = el.attr('href');

    if (href) {
        let splittedUrl = href.split('pid=');

        if (splittedUrl && splittedUrl.length > 1) {
            let pid = splittedUrl[1];

            let splittedPid = pid.split('&');

            return splittedPid[0];
        }
    }

    return href || '';
}

/**
 * Gets product id from quick shop form.
 *
 * @returns {String} product id
 */
function getPidFromQuickShopForm() {
    let pidInput = $('.quickshop #pid');
    let pid = pidInput ? pidInput.val() : '';

    return pid;
}

/**
 * Triggers quick shop event.
 *
 * @param {String} eventName
 * @param {String|undefined} pid
 */
function triggerQuickShopEvent(eventName, pid) {
    if (window.dataLayer) {
        window.dataLayer.push({
            event: eventName,
            ecomm_prodid: pid || getPidFromQuickShopForm()
        });
    }
}

/**
 * General functions
 */

/**
 * Main class to provide Google Tag Manager Tracking
 */
var gtmTracker = {
    init: function () {
        //Add tracking event for Refinement if customer click into filter
        $('body .pt_product-search-result').on('touchstart mousedown', 'a.value-link', function (e) {
            if (e.handled !== true) {
                e.handled = true;
                if (window.dataLayer !== undefined && window.dataLayer) {
                    const $parent = $(this).parent('li');
                    const $eventType = $parent.closest('.refinement').data('attrid');

                    const refinementType = $eventType.split('_').shift();
                    const isSelected = $parent.hasClass('selected') ? 'deselect' : 'select';
                    const label = $parent.attr('data-refinement-info') || $parent.attr('data-refinement-value');

                    window.dataLayer.push({
                        event: 'ga_event_facet',
                        ga_event: {
                            category: 'CLP - Facet',
                            action: `${refinementType}-${isSelected}`,
                            label: label ? decodeURIComponent(label) : ''
                        }
                    });
                }
            }
        });

        //Add tracking event for Refinement if customer click into remove filter box
        $('body .pt_product-search-result').on(
            'touchstart mousedown',
            '.refinement-relax > i.icon-close',
            function (e) {
                if (e.handled !== true) {
                    e.handled = true;
                    if (window.dataLayer !== undefined && window.dataLayer) {
                        var $parent = $(this).parents('li');

                        window.dataLayer.push({
                            event: 'ga_event_facet',
                            ga_event: {
                                category: 'CLP - Facet',
                                action: $parent.data('attrid') + '-deselect',
                                label: $parent.attr('data-refinement-info') || ''
                            }
                        });
                    }
                }
            }
        );

        //Add tracking event for Sorting on product listing
        $('body .pt_product-search-result .sort-by select').on('change', function (e) {
            var $selectedOption = $(this).children('option:selected');
            var sortingID = $selectedOption.data('sort-id');

            if (window.dataLayer !== undefined && window.dataLayer) {
                window.dataLayer.push({
                    event: 'ga_event_sorting',
                    ga_event: {
                        category: 'CLP - Sorting',
                        action: sortingID
                    }
                });
            }
        });

        // Calculate price without tax for GA4 tracking
        let priceWithoutTax = 0;
        if ($('.pt_checkout').length > 0 && $('.order-subtotal .order-totals_price').length > 0) {
            priceWithoutTax = $('.order-subtotal .order-totals_price')
                ?.data('price')
                ?.replace(/[^0-9.]/g, '');
        }

        // Add tracking for order confirmation page
        if ($('.checkout-summary.order-summary-page').length > 0) {
            if (window.dataLayer !== undefined && window.dataLayer) {
                window.dataLayer.push({
                    event: 'view_summary',
                    checkout_step: '04_summary',
                    value: priceWithoutTax
                });
            }
        }

        //Add click tracking for submit order button
        $('.form-row-button .button-submit_order').on('click', function (e) {
            if (window.dataLayer !== undefined && window.dataLayer) {
                window.dataLayer.push({
                    event: 'initiate_purchase',
                    checkout_step: '04_summary',
                    value: priceWithoutTax
                });
            }
        });

        // Add tracking for the shipping page errors
        if ($('.js-checkout-error-placeholder').length > 0 && $('.checkout-shipping-address').length > 0) {
            if (window.dataLayer !== undefined && window.dataLayer) {
                window.dataLayer.push({
                    event: 'shipping_error',
                    checkout_step: '02_1_shipping_error',
                    value: priceWithoutTax
                });
            }
        }
        // Add tracking for the begin checkout step
        $('.cart-action-checkout').on('click', 'button', function () {
            if (window.dataLayer && window.dataLayerCheckout) {
                let couponCode = $('.promo-discount .label').text();
                window.dataLayerCheckout[1].event = 'begin_checkout';
                window.dataLayerCheckout[1].ecommerce.checkout_step = '01_1_cart';
                window.dataLayerCheckout[1].ecommerce.coupon = couponCode.trim() || '';
                window.dataLayer.push(window.dataLayerCheckout[1]);
            }
        });

        // Add tracking for the checkout shipping step
        $('.checkout-address-form .checkout-continue').on('click', 'button', function () {
            if (window.dataLayer && window.dataLayerCheckout) {
                let $shippingMethodList = $('#shipping-method-list');
                window.dataLayerCheckout[1].event = 'add_shipping_info';
                window.dataLayerCheckout[1].ecommerce.checkout_step = '02_shipping';
                window.dataLayerCheckout[1].ecommerce.shipping_tier = $shippingMethodList.find('input:checked').val();
                window.dataLayer.push(window.dataLayerCheckout[1]);
            }
        });

        // Add tracking for the checkout shipping step
        $('.checkout-continue').on('click', '#checkout-billing-submit', function () {
            if (window.dataLayer && window.dataLayerCheckout) {
                window.dataLayerCheckout[1].event = 'add_payment_info';
                window.dataLayerCheckout[1].ecommerce.checkout_step = '03_billing';
                window.dataLayerCheckout[1].ecommerce.payment_type = $('.payment-method-radio:checked').val();
                window.dataLayer.push(window.dataLayerCheckout[1]);
            }
        });

        if ($('.suggested-address').length > 0) {
            if (window.dataLayer !== undefined && window.dataLayer) {
                window.dataLayer.push({
                    event: 'shipping_error',
                    checkout_step: '02_1_shipping_error',
                    value: priceWithoutTax
                });
            }
        }

        // add tracking for the billing page errors
        if ($('#paynext-errors > .error-form').length > 0) {
            if (window.dataLayer !== undefined && window.dataLayer) {
                window.dataLayer.push({
                    event: 'billing_error',
                    checkout_step: '03_1_billing_error',
                    value: priceWithoutTax
                });
            }
        }

        //Add click tracking for promos in carousel-teaser
        $('ul.carousel li[data-promo] a').on('click', function (e) {
            var that = $(this);
            var dataPromo = $(this).closest('li').attr('data-promo');
            var $target = $(e.target);

            if (!$target.hasClass('button')) {
                $target = $target.find('.button');
            }

            if (dataPromo && typeof dataPromo !== typeof undefined) {
                var dataPromoObj = JSON.parse(dataPromo);
                var buttonCreative = $target.text();

                if (window.dataLayer !== undefined && window.dataLayer) {
                    window.dataLayer.push({
                        event: 'promotionClick',
                        ecommerce: {
                            promoClick: {
                                promotions: [
                                    {
                                        id: 'carousel-' + dataPromoObj.id,
                                        name: 'name-' + dataPromoObj.name,
                                        creative: 'creative-' + buttonCreative,
                                        position: 'pos-' + dataPromoObj.pos
                                    }
                                ]
                            }
                        },
                        eventCallback: function () {
                            document.location = that.attr('href');
                        }
                    });
                }
            }
        });

        //Add click tracking for promos in 50%-50%-teaser
        $('.teaser-50-50 div.banner-grid div[data-promo] a').on('click', function (e) {
            var that = $(this);
            var dataPromo = $(this).closest('li').attr('data-promo');

            if (dataPromo && typeof dataPromo !== typeof undefined) {
                var dataPromoObj = JSON.parse(dataPromo);

                if (window.dataLayer !== undefined && window.dataLayer) {
                    window.dataLayer.push({
                        event: 'promotionClick',
                        ecommerce: {
                            promoClick: {
                                promotions: [
                                    {
                                        id: 'id-' + dataPromoObj.id,
                                        name: 'name-' + dataPromoObj.name,
                                        creative: 'creative-' + dataPromoObj.creative,
                                        position: 'pos-' + dataPromoObj.pos
                                    }
                                ]
                            }
                        },
                        eventCallback: function () {
                            document.location = that.attr('href');
                        }
                    });
                }
            }
        });

        $('.teaser-50-50 div.banner-grid div[data-promo]').each(function () {
            var dataPromo = this.attr('data-promo');

            if (dataPromo && typeof dataPromo !== typeof undefined) {
                gtmTracker.trackSliderImpressions(dataPromo);
            }
        });

        $('.js-forgot-password').on('click', () => {
            if (!window.dataLayer) {
                return;
            }

            window.dataLayer.push({
                event: 'ga4_event',
                event_name: 'forgot_password'
            });
        });

        $('.js-log-out').on('click', () => {
            if (!window.dataLayer) {
                return;
            }

            window.dataLayer.push({
                event: 'ga4_event',
                event_name: 'log_out'
            });
        });

        gtmTracker.trackTeaserTileName();
    },

    trackSliderImpressions: function (dataPromo) {
        var dataPromoObj = JSON.parse(dataPromo);

        if (window.dataLayer !== undefined && window.dataLayer) {
            window.dataLayer.push({
                event: 'promotionView',
                ecommerce: {
                    promoView: {
                        promotions: [
                            {
                                id: 'carousel-' + dataPromoObj.id,
                                name: 'name-' + dataPromoObj.name,
                                creative: '',
                                position: 'pos-' + dataPromoObj.pos
                            }
                        ]
                    }
                }
            });
        }
    },

    trackSubmitCheckoutEvenInvoiceDisabled: function (type, value) {
        if (window.dataLayer !== undefined && window.dataLayer) {
            window.dataLayer.push({
                event: 'submitCheckoutEvenInvoiceDisabled',
                ecommerce: {
                    type: type,
                    continueCheckout: value
                }
            });
        }
    },

    trackPDPColorSwitched: function (productData) {
        if (window.dataLayer !== undefined && window.dataLayer) {
            window.dataLayer.push({
                event: 'pdpColorSwitched',
                ecommerce: productData.ecommerce
            });
        }
    },

    trackPDPWidthSwitched: function (productData) {
        if (window.dataLayer !== undefined && window.dataLayer) {
            window.dataLayer.push({
                event: 'width_change',
                ecommerce: productData.ecommerce
            });
        }
    },

    trackPDPWidthSelected: function (productData) {
        if (window.dataLayer !== undefined && window.dataLayer) {
            window.dataLayer.push({
                ecommerce: productData.ecommerce
            });
        }
    },

    /**
     * @function
     * @description initialize search teaser tiles, add event click & scroll on teaser tile
     * @returns {void}
     */
    trackTeaserTileName: () => {
        let $teasers = $('.promo-tile-teaser');

        if ($teasers.length === 0) {
            return;
        }
        $teasers.each(function () {
            let $self = $(this);
            let $window = $(window);
            let isViewEventPushed = false;
            let teaserName = $self.find('[data-teaser-name]').data('teaser-name');

            window.addEventListener('load', function () {
                getTeaserPosition();
            });
            $window.on('scroll', function () {
                getTeaserPosition();
            });

            $self.on('click', 'a', function () {
                if (teaserName && window.dataLayer) {
                    window.dataLayer.push({
                        event: 'promotionClick',
                        ecommerce: {
                            promoClick: {
                                promotions: [
                                    {
                                        name: teaserName
                                    }
                                ]
                            }
                        }
                    });
                }
            });

            /**
             * @function
             * @description check if teaser in viewport
             * @returns {void}
             */
            function isInViewport(el) {
                let elementCoordinates = el.getBoundingClientRect();
                return (
                    elementCoordinates.top > 0 &&
                    elementCoordinates.left >= 0 &&
                    elementCoordinates.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                    elementCoordinates.right <= (window.innerWidth || document.documentElement.clientWidth)
                );
            }

            /**
             * @function
             * @description check if teaser tile visible for user, push data in GTM
             * @returns {void}
             */
            function getTeaserPosition() {
                let teaserElementHtml = $(`[data-teaser-name='${teaserName}'`)[0];

                if (!isViewEventPushed && teaserName) {
                    if (isInViewport(teaserElementHtml)) {
                        if (window.dataLayer !== undefined && window.dataLayer) {
                            window.dataLayer.push({
                                event: 'promotionView',
                                ecommerce: {
                                    promoView: {
                                        promotions: [
                                            {
                                                name: teaserName
                                            }
                                        ]
                                    }
                                }
                            });
                        }
                        isViewEventPushed = true;
                    }
                }
            }
        });
    },
    trackProductSetAddToCart: function (setProductsQtys, setProductsIds, getTrackingDataUrl) {
        let url = (getTrackingDataUrl += setProductsIds);
        url += '&event='.concat('addToCart');
        url += '&setProductsQtys='.concat(setProductsQtys);
        $.ajax({
            type: 'GET',
            url: url,
            success: function (response) {
                if (response) {
                    window.dataLayer.push(response);
                }
            }
        });
    },

    /**

    /**
     * Tracks quick shop flyin initialization.
     *
     * @returns {void}
     */
    trackQuickShopOpenFliyin: () => {
        // Click on the plus button.
        $('.bsd-image-maps__area.marks-item-link').on('click', e => {
            let pid = getPidFromUrl($(e.currentTarget));

            triggerQuickShopEvent('quickShop_button', pid);
        });

        // Click on the image.
        $('.marks-item-link .dist-module-image-img').on('click', e => {
            let button = $(e.currentTarget).closest('a');

            if (button) {
                let href = button.attr('href');

                if (href && href.indexOf('Product-QuickShop') !== -1) {
                    let pid = getPidFromUrl(button);

                    triggerQuickShopEvent('quickShop_picture', pid);
                }
            }
        });
    },

    /**
     * Tracks more details link click on quick shop flyin.
     * @returns {void}
     */
    trackQuickShopMoreDetails: () => {
        $('.quickshop .product-link a').on('click', () => {
            triggerQuickShopEvent('quickShop_moreDetails');
        });
    },

    /**
     * Tracks add to cart action on quick shop flyin.
     * @returns {void}
     */
    trackQuickShopAddToCart: () => {
        triggerQuickShopEvent('quickShop_atc');
    },

    /**
     * Tracks add to wishlist action on quick shop flyin.
     * @returns {void}
     */
    trackQuickShopAddToWishlist: () => {
        triggerQuickShopEvent('quickShop_wishlist');
    },

    /**
     * Adds product data to the data layer.
     *
     * @param {boolean|null} - Indicates if GTM cookie allowed
     * @returns {void}
     */
    initialDatalayerPush: (isGTMCookieAllowed = null) => {
        const isGoogleTagManagerCookieAllowed =
            isGTMCookieAllowed ?? $('#customerDataContainer').data('is-googletagmanager-cookie-allowed');
        const gtmDataContainer = $('#gtmDataContainer').data('gtm-data');

        if (!isGoogleTagManagerCookieAllowed || !gtmDataContainer) {
            return;
        }

        if (typeof window.dataLayer !== 'object') {
            window.dataLayer = [];
        }

        window.dataLayer.push(gtmDataContainer);
    },
    /**
     * Tracks the source of the PLP load.
     *
     * @param {string} source constructor or sfcc
     */
    plpLoad: source => {
        if (window.SitePreferences.ENABLE_PLP_FILTER_TRACKING !== true) {
            return;
        }
        if (window.dataLayer) {
            window.dataLayer.push({
                event: 'ab_test',
                test: 'constructor_vs_sfcc',
                variation: source
            });
        }
    },
    /**
     * Select filter in PLP
     *
     * @param {String} filterType add / remove
     * @param {String} refinement selected refinement
     * @param {String} allRefinements all selected refinements
     * @param {number} resultsCount total number of results
     */
    plpFilterChange: (filterType, refinement, allRefinements, resultsCount) => {
        if (window.SitePreferences.ENABLE_PLP_FILTER_TRACKING !== true) {
            return;
        }
        if (window.dataLayer) {
            let eventId = '';
            switch (filterType) {
                case 'add':
                    eventId = 'add_filter';
                    break;
                case 'remove':
                    eventId = 'remove_filter';
                    break;
                case 'remove_all':
                    eventId = 'remove_all_filters';
                    break;
            }
            if (eventId) {
                const trackingData = {
                    event: eventId,
                    feature: 'filter',
                    all_refinements: allRefinements,
                    results: resultsCount
                };

                if (refinement) {
                    trackingData.refinement = refinement;
                }

                window.dataLayer.push(trackingData);
            }
        }
    }
};

exports.init = gtmTracker.init;

// Quick shop tracking.
exports.trackQuickShopAddToCart = gtmTracker.trackQuickShopAddToCart;
exports.trackQuickShopOpenFliyin = gtmTracker.trackQuickShopOpenFliyin;
exports.trackQuickShopAddToWishlist = gtmTracker.trackQuickShopAddToWishlist;
exports.trackQuickShopMoreDetails = gtmTracker.trackQuickShopMoreDetails;

exports.trackSliderImpressions = gtmTracker.trackSliderImpressions;
exports.trackPDPColorSwitched = gtmTracker.trackPDPColorSwitched;
exports.trackPDPWidthSwitched = gtmTracker.trackPDPWidthSwitched;
exports.trackPDPWidthSelected = gtmTracker.trackPDPWidthSelected;
exports.trackSubmitCheckoutEvenInvoiceDisabled = gtmTracker.trackSubmitCheckoutEvenInvoiceDisabled;
exports.trackTeaserTileName = gtmTracker.trackTeaserTileName;
exports.trackProductSetAddToCart = gtmTracker.trackProductSetAddToCart;
exports.initialDatalayerPush = gtmTracker.initialDatalayerPush;
exports.plpLoad = gtmTracker.plpLoad;
exports.plpFilterChange = gtmTracker.plpFilterChange;
